/**
 * 안전한 리다이렉트를 위한 URL 검증 유틸리티
 */

/**
 * URL이 현재 도메인과 동일한지 확인
 * @param url 검증할 URL 문자열
 * @returns 현재 도메인과 동일하면 true, 아니면 false
 */
export function isSameDomain(url: string): boolean {
  try {
    // 상대 경로인 경우 안전하다고 판단
    if (url.startsWith('/') && !url.startsWith('//')) {
      return true;
    }

    // 절대 URL 파싱
    const targetUrl = new URL(url, window.location.origin);
    const currentUrl = new URL(window.location.href);

    // 호스트(도메인)와 프로토콜이 동일한지 확인
    return (
      targetUrl.hostname === currentUrl.hostname &&
      targetUrl.protocol === currentUrl.protocol
    );
  } catch (_error) {
    // URL 파싱 실패 시 안전하지 않다고 판단
    console.warn('Invalid URL for redirect:', url);
    return false;
  }
}

/**
 * 안전한 리다이렉트 URL 반환
 * @param url 검증할 URL
 * @param fallbackUrl 기본값 URL (기본값: '/public')
 * @returns 안전한 URL 또는 fallback URL
 */
export function getSafeRedirectUrl(
  url: string | undefined | null,
  fallbackUrl: string = '/public',
): string {
  if (!url) {
    return fallbackUrl;
  }

  return isSameDomain(url) ? url : fallbackUrl;
}
